export default (function () {

  let DOM = {};

  let ajax_data = {
    'action': 'pw_get_posts',
    // eslint-disable-next-line no-undef
    'nonce': ajax_object.nonce,
    // eslint-disable-next-line no-undef
    'query_vars': ajax_object.query_vars,
    // eslint-disable-next-line no-undef
    'current_page': ajax_object.current_page,
    // eslint-disable-next-line no-undef
    'max_num_pages': ajax_object.max_num_pages,
  };

  function cacheDom() {
    DOM.item = document.querySelector('[data-module="loadmore"]');
  }

  function bindUIActions() {
    DOM.trigger = DOM.item.querySelector('[data-trigger]');
    DOM.container = DOM.item.querySelector('[data-container]');
    DOM.loader = DOM.trigger.querySelector('svg');

    DOM.trigger.addEventListener('click', loadMore);
  }

  function loadMore() {
    $.ajax({
      type: 'POST',
      // eslint-disable-next-line no-undef
      url:  ajax_object.url,
      data: ajax_data,
      beforeSend: function () {
        DOM.trigger.setAttribute('disabled', '');
        DOM.loader.classList.remove('hidden');
      },
      success: function (data) {
        if (data) {
          let parsed_data = JSON.parse(data);
          //console.log(parsed_data);
          DOM.container.innerHTML += parsed_data;
          ajax_data.current_page++;

          if(ajax_data.current_page >= ajax_data.max_num_pages) {
            DOM.trigger.parentNode.remove();
          }

        } else {
          DOM.trigger.parentNode.remove();
        }
      },
      complete: function () {
        DOM.loader.classList.add('hidden');
        DOM.trigger.removeAttribute('disabled');
      },
      error: function (request) {
        console.log(request.responseText);
      },
    });
  }

  function init() {
    cacheDom();

    if (DOM.item) {
      bindUIActions();
    }

  }

  return {
    init: init,
  }
})();

